import Laminado from '../Image/CejasPestañas/laminado.png'
import Liffting from '../Image/CejasPestañas/liffting.png'
import Perfilado from '../Image/CejasPestañas/perfilado.png'
import Permanente from '../Image/CejasPestañas/permanente.png'
import Ramillete from '../Image/CejasPestañas/ramillete.png'



const DataCejasPestañas = [
    {
        img: Laminado,
        title: "Laminado de Cejas",
        description: "Se trata de un tratamiento semipermanente que se aplica sobre el vello de la ceja y consigue un efecto de ceja “peinada” hacia arriba, alisando el pelo más rebelde y fijando la forma deseada.",
        duracion: "60 min"
    },
    {
        img: Perfilado,
        title: "Perfilado de Cejas",
        description: "Consiste en el diseño y modelado de las cejas de acuerdo con la estructura de tu rostro, tus ojos y nariz. El objetivo del perfilado no es seguir el patrón de ceja que está de moda, sino perfeccionar su forma natural",
        duracion: "60 min"

    },
    {
        img: Liffting,
        title: "Lifting de Pestañas",
        description: "Es un tratamiento que alarga y crea una ligera curva hacia arriba de manera natural y duradera, consiguiendo mayor longitud y espesor. Para aquellas que tengan las pestañas medias o largas, rectas o sin forma, y deseen conseguir un resultado natural,",
        duracion: "60 min"
    },
    {
        img: Permanente,
        title: "Permanente de Pestañas",
        description: " Es un tratamiento que riza las pestañas naturales y consigue que estas tengan una curvatura más pronunciada, lo que sin duda hará que se realce la expresividad de tu mirada y que tus ojos tengan una imagen mucho más impactante.",
        duracion: "60 min"
    },
    {
        img: Ramillete,
        title: "Extensión en Ramillete",
        description: "Se trata de un trabajo artesanal mediante el cual se aplican pestañas en ramilletes de 3 pelos, los cuales podes elegir entre una amplia variedad de tamaños y grosor, logrando un efecto sumamente natural y dando como resultado pestañas sensuales y espesas.",
        duracion: "30 min"
    }

]

export default DataCejasPestañas;